import { Box } from "@mui/material";

interface AspectRatioIconProps {
  dimensions: [number, number];
}

// TODO: Should be a SVG icon
export const AspectRatioIcon = ({ dimensions }: AspectRatioIconProps) => {
  const [w, h] = dimensions;

  if (w <= 0 || h <= 0) return null;

  const maxSize = 20;
  const scale = Math.min(maxSize / w, maxSize / h);
  const scaledWidth = w * scale;
  const scaledHeight = h * scale;

  return (
    <Box
      sx={{
        width: 28,
        height: 28,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: scaledWidth,
          height: scaledHeight,
          border: "1px solid",
          borderColor: "secondary.3",
          position: "relative",
          borderRadius: "4px",
          padding: "2px",
          transition: "all 200ms ease-in-out",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 2,
            left: 2,
            width: 4,
            height: 4,
            borderTop: "1px solid",
            borderLeft: "1px solid",
            borderColor: "secondary.3",
            borderRadius: "1px",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 2,
            right: 2,
            width: 4,
            height: 4,
            borderBottom: "1px solid",
            borderRight: "1px solid",
            borderColor: "secondary.3",
            borderRadius: "1px",
          }}
        />
      </Box>
    </Box>
  );
};
